import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var brandSchema = {
    name: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Име *',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно име',
    }),
    slug: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Slug *',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валиден slug',
    }),
    position: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'number',
        }),
        elementType: 'input',
        label: 'Позиция',
        value: 50,
        validation: {
            required: false
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въведете валидна позиция',
    }),
    description: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'textarea',
        label: 'Описание',
        value: '',
        validation: {
            required: false
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въведете валидно описание',
    }),
    logo_url: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'image',
        label: 'Aдрес картинка',
        value: null,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валиден адрес',
    }),
    meta_title: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'input',
        label: 'Meta Заглавие',
        value: '',
        validation: {
            required: false
        },
        valid: true,
        touched: true,
        errorMsg: 'Моля, въведете валидно заглавие',
    }),
    meta_description: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'textarea',
        label: 'Meta Описание',
        value: '',
        validation: {
            required: false
        },
        valid: true,
        touched: true,
        errorMsg: 'Моля, въведете валидно описание',
    }),
    black_border: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'checkbox',
        label: 'Черна лента',
        value: false,
        validation: {
            required: false
        },
        valid: true,
        touched: false,
        errorMsg: 'Трябва да бъде селектирано',
    }),
    hidden: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'checkbox',
        label: 'Скрита Марка',
        value: false,
        validation: {
            required: false
        },
        valid: true,
        touched: false,
        errorMsg: 'Трябва да бъде селектирано',
    }),
    bg_seo_description: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'textarea',
        label: 'SEO Текст на български',
        value: '',
        validation: {
            required: false,
        },
        valid: true,
        touched: true,
        errorMsg: 'Моля, въвдете валидно име на български',
    }),
    en_seo_description: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'textarea',
        label: 'SEO Текст на английски',
        value: '',
        validation: {
            required: false,
        },
        valid: true,
        touched: true,
        errorMsg: 'Моля, въвдете валидно име на английски',
    }),
};
export default brandSchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/brandSchema.ts
// module id = 536
// module chunks = 0